import accessories from './config/accessories';
import achievements from './config/achievements';
import adventures from './config/adventures';
import allItems from './config/allItems';
import cityUpgrades from './config/cityUpgrades';
import collabBlocks from './config/collabBlocks';
import flipTokenChoices from './config/flipTokenChoices';
import memes from './config/memes';
import raffleOwners from './config/raffleOwners';
import { shuffleTraits } from './config/shuffleTraits';
import stickers from './config/stickers';
import treasureBoxes from './config/treasureBoxes';

const config = {
  siteName: 'Shitty Kitties',
  twitter: 'https://twitter.com/ShittyKitties_',
  discord: 'https://www.discord.gg/qRafNzFjkN',
  buyNow: 'https://market.downbad.farm/collection/shitty-kitties',
  buyNowSecondLitter: 'https://market.downbad.farm/collection/shitty-kitties-slt',
  buyNowThirdLitter: 'https://market.downbad.farm/collection/shitty-kitties-third-litter',

  docs: 'https://docs.shittykitties.art/',
  allAccessories: accessories,
  allItems: allItems,
  flipTokenChoices: flipTokenChoices,
  raffleOwners: raffleOwners,
  treasureBoxes: treasureBoxes,
  adventures: adventures,
  achievements: achievements,
  memes: memes,
  stickers: stickers,

  citiesCollectionName: 'shitty_cities',
  citizensCollectionName: 'shitty_cities_citizens',
  collabBlockStakingCollectionName: 'collab_block_staking',

  collabBlocks: collabBlocks,
  cityUpgrades: cityUpgrades,

  blockTypes: {
    restaurants: [1102790639, 1102791660, 1102793225, 1102793354, 1102795932, 1102797240],
    entertainment: [
      1102790776, 1102791858, 1102792471, 1102792839, 1102792942, 1102792373, 1102792980, 1102793144, 1102793193, 1102793315, 1102793536, 1102793572,
      1102794250, 1102794370, 1102795000, 1102795248, 1102796177, 1102796452, 1102796191, 1102796597, 1102796840, 1102797363, 1102797697, 1102797547,
      1195948055,
    ],
    wasteCleanUp: [1102796615],
  },

  traitSwapMaxNfts: 2,
  traitSwapMaxLayers: 4,

  traitSwapTreatsCost: parseInt(process.env.NEXT_PUBLIC_TRAIT_SWAP_TREATS_COST),
  traitSwapAlgoCost: parseInt(process.env.NEXT_PUBLIC_TRAIT_SWAP_ALGO_COST),

  traitShuffleTreatsCost: parseInt(process.env.NEXT_PUBLIC_TRAIT_SHUFFLE_TREATS_COST),
  traitShuffleAlgoCost: parseInt(process.env.NEXT_PUBLIC_TRAIT_SHUFFLE_ALGO_COST),

  fourthLitterTraitLayers: ['Background', 'Fur', 'Clothing', 'Accessory', 'Whiskers', 'Mouth', 'Eyes', 'Head'],
  fourthLitterTraitLayersForShuffle: [
    // 'Background',
    'Fur',
    'Clothing',
    'Accessory',
    'Head',
    // 'Mouth',
  ],

  // add banned traits here
  bannedTraits: [],

  traitsThatRequireOtherTraits: [
    {
      trait: 'Brown Wig with Sideburns',
      traitLayer: 'Head',
      requiredTraitLayer: 'Whiskers',
      requiredTraitValue: 'Normal',
    },
    {
      trait: 'Adventure Hat',
      traitLayer: 'Head',
      requiredTraitLayer: 'Whiskers',
      requiredTraitValue: 'Normal',
    },
    {
      trait: 'Slime Wig',
      traitLayer: 'Head',
      requiredTraitLayer: 'Whiskers',
      requiredTraitValue: 'Normal',
    },
    {
      trait: 'Magician Costume',
      traitLayer: 'Clothing',
      requiredTraitLayer: 'Fur',
      requiredTraitValue: 'Normal',
    },
    {
      trait: 'Muscle Suit',
      traitLayer: 'Clothing',
      requiredTraitLayer: 'Fur',
      requiredTraitValue: 'Normal',
    },
    {
      trait: 'Hero Costume',
      traitLayer: 'Clothing',
      requiredTraitLayer: 'Fur',
      requiredTraitValue: 'Normal',
    },
    {
      trait: 'Ivory Himation',
      traitLayer: 'Clothing',
      requiredTraitLayer: 'Fur',
      requiredTraitValue: 'Normal',
    },
  ],

  flaggableTraits: ['Zombie', 'Umbrella', 'Skis', 'Lazers', 'Space Helmet', 'Puffy Winter Coat'],
  traitsWithMultipleOptions: [
    'Thermal Cup',
    'Baseball Bat',
    'Boxing Gloves',
    'Lightsaber',
    'Milk',
    'Video Game',
    'Soccer Uniform',
    'Boxing Shorts',
    'Beanie',
    'Headband',
    'Bow Tie',
    'Track Suit',
    'Fish Bowl',
    'Pie Dress',
    'Leaves',
  ],

  shuffleTraits,

  vmMemeCoins: [
    // {
    //   assetId: 2727023035,
    //   name: '$WIT',
    //   min: 0.5, // USD
    //   max: 2.0, // USD
    //   image: '/vm-meme-coins/wit.png',
    //   decimals: 6,
    // },
  ],

  donationConfig: {
    enabled: process.env.NEXT_PUBLIC_DONATIONS_ENABLED === 'true',
    maxAssetsPerDonation: parseInt(process.env.NEXT_PUBLIC_MAX_DONATION_ASSETS) || 10,
    rateLimit: parseInt(process.env.NEXT_PUBLIC_DONATION_RATE_LIMIT) || 10,
    destination: {
      id: 'shitty-vault',
      name: 'Shitty Vault',
      address: process.env.NEXT_PUBLIC_SHITTY_VAULT_ADDRESS,
    },
  },

  kittyCleanup: {
    enabled: process.env.NEXT_PUBLIC_KITTY_CLEANUP_ENABLED === 'true',
    adminAddresses: process.env.KITTY_CLEANUP_ADMIN_ADDRESSES?.split(',') || [],
    supportedGeneration: 4,
  },

  skClub: {
    enabled: process.env.NEXT_PUBLIC_FISHIES_ENABLED === 'true',
    exchangeEnabled: process.env.NEXT_PUBLIC_FISHIES_EXCHANGE_ENABLED === 'true',
    coinsToTreatsEnabled: process.env.NEXT_PUBLIC_FISHIES_COINS_TO_TREATS_ENABLED === 'true',
    treatsPerCoin: parseInt(process.env.NEXT_PUBLIC_TREATS_PER_COIN) || 20,
    coinsPerTreat: parseInt(process.env.NEXT_PUBLIC_COINS_PER_TREAT) || 30,
    minTreatsExchange: parseInt(process.env.NEXT_PUBLIC_MIN_TREATS_EXCHANGE) || 20,
    minCoinsExchange: parseInt(process.env.NEXT_PUBLIC_MIN_COINS_EXCHANGE) || 30,
    // Weekly caps are per wallet, shared by every game account linked to it.
    weeklyCoinsInCap: parseInt(process.env.NEXT_PUBLIC_WEEKLY_COINS_IN_CAP) || 5000,
    weeklyTreatsOutCap: parseInt(process.env.NEXT_PUBLIC_WEEKLY_TREATS_OUT_CAP) || 500,
    // First game version that applies the exchange ledger. Older clients would
    // never receive credited coins and never lose debited ones.
    minAppVersion: process.env.NEXT_PUBLIC_FISHIES_EXCHANGE_MIN_APP_VERSION || '1.4.1',
  },
};

export default config;
